import React from 'react'
import { connect } from 'react-redux'
// import Bar from './Bar';
import {
    ajaxBlockUser,
    ajaxFeedback,
    ajaxFeedbackFilterV2,
    deselectFeedback,
    getChatIcons,
    getEmail,
    getFeedbackLength,
    getPhone,
    getRequestedViaV2,
    getSmiley,
    setCurrentPage,
    setLocation,
    setSelectedFeedback
} from '../redux/FeedbackRedux'

class FeedbackDetailBar extends React.Component {
    constructor(props) {
        super(props);
        this.pageDetailDirection = null;
        setLocation('FeedbackDetailBar');
    }

    onPrevClick() {
        jQuery('.tooltip.show').remove();
        this.props.dispatch(deselectFeedback());
        window.history.pushState(null, null, window.location.href.split("?")[0]);
    }

    getfirstLast() {
        let firstIndex = this.props.state.initial_feedbacks ? 0 : null;
        let lastIndex = this.props.state.initial_feedbacks ? this.props.state.initial_feedbacks.length - 1 : null;

        return {
            first: this.props.state.initial_feedbacks[firstIndex].id || null,
            last: this.props.state.initial_feedbacks[lastIndex].id || null,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.state.initial_feedbacks !== prevProps.state.initial_feedbacks
            && this.pageDetailDirection !== null
        ) {
            let firstLast = this.getfirstLast();

            if (this.pageDetailDirection === 'next') {
                this.pageDetailDirection = null
                this.props.dispatch(setSelectedFeedback(firstLast.first));
                this.props.dispatch(ajaxFeedback(firstLast.first));

            } else if (this.pageDetailDirection === 'prev') {
                this.pageDetailDirection = null
                this.props.dispatch(setSelectedFeedback(firstLast.last));
                this.props.dispatch(ajaxFeedback(firstLast.last));
            }
        }
    }

    onNextItemClick() {
        let nextId = this.props.state.feedback_detail.next_id;

        if (!nextId && this.props.state.current_page !== Math.ceil(this.props.state.feedback_count / this.props.state.paginate_count)) {
            this.doPagination('next');
            return;
        } else if (nextId === null) {
            return;
        }


        this.props.dispatch(setSelectedFeedback(nextId));
        this.props.dispatch(ajaxFeedback(nextId));
    }

    onPrevItemClick() {
        let prevId = this.props.state.feedback_detail.prev_id;

        if (prevId === null && this.props.state.current_page > 1) {
            this.doPagination('prev');
            return;
        } else if (prevId === null) {
            return;
        }

        this.props.dispatch(setSelectedFeedback(prevId));
        this.props.dispatch(ajaxFeedback(prevId));
    }

    doPagination(direction) {
        let e = event.target;
        let current = this.props.state.current_page;
        switch (direction) {
            case "next":
                current += 1;
                break;
            case "prev":
                current -= 1;
                break;
        }
        this.props.dispatch(setCurrentPage(current));
        this.props.dispatch(ajaxFeedbackFilterV2());
        this.pageDetailDirection = direction;
    }

    onBlockClick() {
        const message = this.props.state.feedback_detail.user.blocks.length === 0 ?
            __("Are you sure you want to block this user from submitting future Feedbacks?") :
            __("Are you sure you want to unblock this user from submitting future Feedbacks?");
        if (!window.confirm(message)) {
            return;
        }
        this.props.dispatch(ajaxBlockUser(this.props.state.feedback_detail.business_id, this.props.state.feedback_detail.feedback_id));
    }

    render() {
        let feedback = this.props.state.feedback_detail;
        let firstName = feedback.is_include_contact && feedback.user.firstname ? feedback.user.firstname : "";
        let lastName = feedback.is_include_contact && feedback.user.lastname ? feedback.user.lastname : "";
        let usernameString = firstName + " " + lastName;
        let username = <span>{usernameString.trim().length == 0 ? "Anonymous" : usernameString}</span>;
        let iconList = getChatIcons(feedback, "");
        let requestedString = getRequestedViaV2(feedback);
        let smiley = getSmiley(feedback);
        let dow = (feedback.dow != "" ? feedback.dow + ", " : "") + feedback.created_at;

        return (
            <>
                <div className="d-none d-xl-flex w-100 align-items-center p-2 bg-white border-bottom shadow-sm">
                    {/* back to feedback history */}
                    <div className="mr-1">
                        {!this.props.isSelectedFeedback && <h4
                            data-toggle="tooltip"
                            data-placement="top"
                            data-title={this.props.chatPage ? __('Back to Chat History') : __('Back to Feedback History')}
                            onClick={this.onPrevClick.bind(this)} data-direction="prev" className="left-carat cursor-pointer mb-0"></h4>}
                    </div>

                    <div className="mr-4">
                        <div className="d-flex align-items-center ml-1">
                            <h3 className="d-inline-block mb-0 mr-1 feedback-details-d-name">{username}</h3> {smiley}
                            {
                                (!!feedback.is_include_contact && (feedback.user.firstname?.length > 0 || feedback.user.lastname?.length > 0)) &&
                                <>
                                    {feedback.user.blocks.length !== 0 && (
                                            <span className="btn btn-sm btn-outline-secondary ml-2 cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-title={__('Unblock user from submitting future Feedbacks')}
                                                onClick={this.onBlockClick.bind(this)} >
                                                <svg className="mr-1" width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#a)" fill="#000"><path d="M4.787 0C6.26.001 7.36 1.113 7.353 2.596c-.005 1.47-1.123 2.568-2.604 2.56-1.438-.01-2.534-1.119-2.537-2.568C2.21 1.106 3.312-.002 4.787 0Zm.016.782c-.946-.017-1.813.844-1.81 1.798.003.917.845 1.772 1.766 1.792.928.02 1.818-.863 1.813-1.8C6.567 1.655 5.722.8 4.803.783ZM10 7.55C9.997 8.956 8.933 10.007 7.52 10 6.118 9.993 5.077 8.921 5.09 7.5 5.1 6.122 6.158 5.078 7.542 5.077c1.409 0 2.462 1.059 2.46 2.472H10ZM7.536 5.86c-.858.006-1.661.811-1.666 1.672-.004.857.79 1.668 1.654 1.686.873.017 1.712-.826 1.695-1.7-.017-.866-.829-1.665-1.683-1.658Z"/><path d="M2.704 9.543c-.594 0-1.187.013-1.781-.003-.605-.017-.837-.291-.904-.884-.136-1.204.422-1.974 1.448-2.491.943-.474 1.954-.657 2.993-.718.312-.018.677-.008.672.424-.003.383-.347.41-.64.417-1.049.027-2.053.223-2.958.787-.39.244-.676.56-.734 1.042-.056.449.073.677.584.66.957-.031 1.915-.01 2.873-.008.153 0 .307 0 .459.01.234.016.416.118.417.38 0 .263-.185.373-.418.375-.67.01-1.341.003-2.01.003v.007ZM8.828 6.993c-.014.165-.114.28-.222.391-.202.206-.403.41-.607.613-.613.613-.995.61-1.576-.007-.144-.152-.226-.318-.109-.516.117-.196.332-.266.494-.142.433.33.682.074.95-.226.14-.156.3-.296.463-.428a.355.355 0 0 1 .43-.024c.124.076.18.193.175.338l.002.001Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h10v10H0z"/></clipPath></defs></svg>
                                                { __('Unblock User') }
                                            </span>
                                    )}
                                    {feedback.user.blocks.length === 0 && (
                                        <span className="btn btn-sm btn-outline-secondary ml-2 cursor-pointer"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-title={__('Block user from submitting future Feedbacks')}
                                            onClick={this.onBlockClick.bind(this)} >
                                                <svg className="mr-1" width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#a)" fill="#000"><path d="M10.045 7.511C10.053 8.93 9.005 9.996 7.604 10c-1.408.004-2.468-1.054-2.468-2.463 0-1.388 1.04-2.448 2.412-2.46 1.417-.012 2.489 1.033 2.497 2.434ZM5.92 7.52c.006.039.007.118.03.19.057.179.021.43.217.509.222.09.324-.154.452-.28.495-.48.97-.982 1.468-1.461.334-.32.227-.452-.17-.554-.934-.238-1.968.56-1.997 1.596Zm3.341.015c-.07-.215.01-.573-.272-.675-.233-.084-.366.228-.524.38-.47.453-.918.926-1.387 1.38-.302.296-.215.425.157.526.955.262 2.023-.56 2.025-1.61h.001ZM4.826 0C6.3 0 7.402 1.107 7.4 2.588 7.395 4.06 6.282 5.162 4.803 5.154c-1.442-.007-2.54-1.111-2.544-2.56C2.255 1.11 3.353 0 4.826 0Zm.008.782c-.95-.003-1.81.865-1.793 1.814.015.921.866 1.769 1.78 1.776.935.007 1.815-.884 1.798-1.817C6.6 1.633 5.749.787 4.834.783Z"/><path d="M2.781 9.542c-.612 0-1.225.014-1.838-.005C.37 9.52.137 9.243.068 8.685c-.148-1.2.393-1.983 1.42-2.506.957-.49 1.987-.674 3.045-.734.294-.016.63.004.647.394.017.392-.315.439-.61.446-1.07.028-2.091.22-3.01.804-.39.247-.665.569-.714 1.054-.042.42.07.646.555.632.957-.027 1.915-.008 2.872-.007.153 0 .307-.003.459.007.257.015.463.114.446.409-.014.261-.216.35-.445.352-.65.007-1.302.002-1.953.002v.003h.001Z"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.045)" d="M0 0h10v10H0z"/></clipPath></defs></svg>
                                            { __('Block User') }
                                        </span>
                                    )}
                                </>
                            }
                        </div>
                    </div>

                    {/* User details — all on one line */}
                    <div className="mr-4 d-flex align-items-center flex-wrap">
                        <span className="d-flex align-items-center mr-4">
                            <span className="font-bold mr-1">{__("Email")}:</span>
                            {!feedback?.user?.email || feedback?.user?.email?.length === 0
                                ? <span>{__("none")}</span>
                                : <a href={`mailto:${feedback.user.email}`} target="_blank">{feedback.user.email}</a>
                            }
                        </span>

                        <span className="d-flex align-items-center mr-4">
                            <span className="font-bold mr-1">{__("Phone")}:</span>
                            <span>{usernameString.replace("Anonymous", "").trim().length == 0 ? "None" : getPhone(feedback)}</span>
                        </span>

                        <span className="d-flex align-items-center">
                            <span className="font-bold mr-1">{__("Feedbacks")}:</span>
                            <span>{getFeedbackLength(feedback)}</span>
                        </span>
                    </div>

                    {/* Reponse Requestd */}
                    <div className="d-flex align-items-center feedback-details-d-requested mr-auto">
                        {iconList?.props?.children && iconList?.props?.children[3] === "-" ? '' : iconList} <h4 className="font-bold ml-2 mb-0">{requestedString}</h4>
                    </div>

                    {/* Feedback Navigation */}
                    {
                        window.location.pathname.includes('detail') === true
                            ? '' :
                            <div className="col-3 d-sm-none d-md-block">
                                <div className="row justify-content-end mr-1 actions-prev-next-btn-group">
                                    <button
                                        className={((this.props.state.feedback_detail.prev_id === null && this.props.state.current_page === 1) ? 'btn-secondary ' : 'btn-primary ') + 'btn mr-3 d-flex items-center feedback-nav-btn'}
                                        onClick={this.onPrevItemClick.bind(this)}
                                        disabled={this.props.state.feedback_detail.prev_id === null && this.props.state.current_page === 1}>
                                        <i className="fas fa-chevron-left mr-2"/> {__('Previous')}
                                    </button>
                                    <button
                                        className={((this.props.state.feedback_detail.next_id === null && this.props.state.current_page === Math.ceil(this.props.state.feedback_count / this.props.state.paginate_count)) ? 'btn-secondary ' : 'btn-primary ') + 'btn d-flex items-center feedback-nav-btn'}
                                        onClick={this.onNextItemClick.bind(this)}
                                        disabled={(this.props.state.feedback_detail.next_id === null && this.props.state.current_page === Math.ceil(this.props.state.feedback_count / this.props.state.paginate_count))}>{__('Next')}
                                        <i className="fas fa-chevron-right ml-2"/>
                                    </button>
                                </div>
                            </div>
                    }
                </div>

                {/*mobile here*/}
                <div className={'d-block d-xl-none feedback-details-top-wrapper'}>
                    <div className={'align-items-center w-100 lg:p-2 bg-white border-bottom shadow-sm d-flex'}>
                        <div className={'d-flex justify-content-between w-100 flex-wrap	pt-2 pl-4 pr-4 pb-3'}>
                            {/* row */}
                            <div className="row w-100">
                                {(!this.props.hideBackArrow || this.props.hideBackArrow === undefined) &&
                                    <div className="mr-1 d-flex align-items-center feedback-details-back">
                                        <h4
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-title={this.props.showChat ? __('Back to Feedback History Details') : __('Back to Feedback History')}
                                            onClick={this.props.showChat ? this.props.toggleChat : this.onPrevClick.bind(this)}
                                            data-direction="prev" className="left-carat cursor-pointer mb-0"></h4>
                                    </div>
                                }
                                <div className={this.props.hideBackArrow ? "ml-3 " : "" + "mr-3 feedback-details-name"}>
                                    <div className="d-flex align-items-center">
                                        <h3 className="d-inline-block mb-0 mr-1">{username}</h3> {smiley}
                                    </div>
                                    <div className="d-flex align-items-center feedback-details-icons-v2">
                                        {iconList ?? __("Response Not Requested")}
                                    </div>
                                </div>
                            </div>

                            <div className={'d-flex flex-column feedback-details-top-details'}>
                                <div>
                                    <span className="font-bold">{'Email: '}</span>
                                    <span>{getEmail(feedback)}</span>
                                </div>
                                <div className={'d-flex justify-content-between align-items-start lg:align-items-center flex-column lg:flex-row items-start'}>
                                    <div>
                                        <span className="font-bold">{'Phone: '}</span>
                                        <span>{getPhone(feedback)}</span>
                                    </div>
                                </div>
                            </div>
                            {
                                window.location.pathname.includes('detail') === true
                                    ? '' :
                                    <div className={'d-flex flex-column justify-content-center'}>
                                        <div
                                            className="d-flex flex-row w-100 lg:w-auto align-items-center justify-content-between lg:mx-3 actions-second actions-prev-next-btn-group">
                                            <button
                                                className={((this.props.state.feedback_detail.prev_id === null && this.props.state.current_page === 1) ? 'btn-secondary ' : 'btn-primary ') + 'btn btn-sm mr-3 d-flex items-center feedback-nav-btn'}
                                                onClick={this.onPrevItemClick.bind(this)}
                                                disabled={this.props.state.feedback_detail.prev_id === null && this.props.state.current_page === 1}><i
                                                className="fas fa-chevron-left mr-2"/> {__('Previous')}</button>
                                            <button
                                                className={((this.props.state.feedback_detail.next_id === null && this.props.state.current_page === Math.ceil(this.props.state.feedback_count / this.props.state.paginate_count)) ? 'btn-secondary ' : 'btn-primary ') + 'btn btn-sm d-flex items-center feedback-nav-btn'}
                                                onClick={this.onNextItemClick.bind(this)}
                                                disabled={(this.props.state.feedback_detail.next_id === null && this.props.state.current_page === Math.ceil(this.props.state.feedback_count / this.props.state.paginate_count))}>{__('Next')}<i
                                                className="fas fa-chevron-right ml-2"/></button>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        state: state
    }
}

export default connect(mapStateToProps)(FeedbackDetailBar);
